import Icon from '../components/Icon.vue'

Icon.register({"arrows-alt":{"width":512,"height":512,"paths":[{"d":"M352.2 425.8L273 505C263.6 514.3 248.4 514.3 239.1 505L159.9 425.8C144.7 410.7 155.5 384.8 176.8 384.8H228L228 284H127.2V335.2C127.2 356.5 101.3 367.3 86.2 352.1L7 272.9C-2.3 263.6-2.3 248.4 7 239L86.2 159.8C101.3 144.7 127.2 155.4 127.2 176.8V228H228V127.2H176.8C155.4 127.2 144.7 101.3 159.8 86.2L239 7C248.4-2.3 263.6-2.3 272.9 7L352.1 86.2C367.3 101.3 356.5 127.2 335.2 127.2H284V228H384.8V176.8C384.8 155.5 410.7 144.7 425.8 159.9L505 239.1C514.3 248.4 514.3 263.6 505 273L425.8 352.2C410.7 367.3 384.8 356.6 384.8 335.2V284H284V384.8H335.2C356.6 384.8 367.3 410.7 352.2 425.8z"}]}})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/arrows-alt.js
// module id = Mzu/
// module chunks = 0